import { gql } from '@apollo/client';
import { WarrantyInfoShared } from '../fragments';

export default gql`
  query warranties(
    $accountId: ID
    $partnerOrganizationId: [ID!]
    $partnerLocationId: [ID!]
    $partnerUserId: ID
    $patientId: ID
    $userId: ID
    $manufacturerId: ID
    $status: String
    $states: [String!]
    $sources: [String!]
    $createdAtStart: String
    $createdAtEnd: String
  ) {
    warranties(
      accountId: $accountId
      partnerOrganizationId: $partnerOrganizationId
      partnerLocationId: $partnerLocationId
      partnerUserId: $partnerUserId
      patientId: $patientId
      userId: $userId
      manufacturerId: $manufacturerId
      status: $status
      states: $states
      sources: $sources
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
    ) {
      ...WarrantyInfoShared
    }
  }
  ${WarrantyInfoShared}
`;
